import type { ChangeEvent } from 'react';
import { useContext, useMemo, useState } from 'react';

import { SECTION } from 'src/constants/section';
import { AccordionContext } from 'src/components/common/Accordion';
import { CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/constants';
import { useCreateActionItemContext } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/CreateActionItemContext';
import useFetchSurveyList from 'src/components/survey/SurveyContext/ListContext/useFetchSurveyList';

export const useSelectSurvey = () => {
  const { toggleActiveState } = useContext(AccordionContext);
  const { surveyId, setSurvey } = useCreateActionItemContext();
  const { data: surveys, isFetching, isLoading, error } = useFetchSurveyList();

  const [searchTerm, setSearchTerm] = useState('');

  const filteredSurveys = useMemo(() => {
    if (!surveys) return [];
    return surveys.filter(
      (survey) =>
        survey.accessibleModulePermissions.find(
          (permission) => permission.moduleType === SECTION.FOLLOW_UP_ACTION,
        ) &&
        (searchTerm === '' ||
          survey.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          survey.year.toString().includes(searchTerm)),
    );
  }, [searchTerm, surveys]);

  const selectedSurveyName = useMemo(() => {
    const selectedSurvey = surveys?.find((survey) => survey.id === surveyId);
    return selectedSurvey ? selectedSurvey.name : '';
  }, [surveys, surveyId]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleSurveySelect = (event: ChangeEvent<HTMLInputElement>) => {
    setSurvey(surveys?.find(({ id }) => id === Number(event.target.value)));
    toggleActiveState(CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES.ORG_UNIT);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };
  return {
    filteredSurveys,
    searchTerm,
    selectedSurveyName,
    handleSurveySelect,
    handleSearchChange,
    handleClearSearch,
    isLoading,
    isFetching,
    error,
  };
};
